import React, { Component } from "react";
import Logo from "../images/logo-lakme.png";
import phoneImg from "../images/telephone.png";
import $ from "jquery";
import { dataUpdate, saveItCareerForm } from '../service'
var EnqNo = localStorage.getItem('EnqNo')
const cityNameUrl = window.location.host
class Thankyou extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: localStorage.getItem('Name'),
      phone: localStorage.getItem('PhoneNumber')
    }
  }
  componentDidMount() {
    if (EnqNo == "" || EnqNo == "null" || EnqNo == null) {
      window.location.href = '/'
    }
    $("#CallYouBack").hide();
    this.sendWhatsAppSms()
    this.sendEmail()
    setTimeout(() => {
      window.location.href = "/"
    }, 120000);
  }
  sendEmail = (e) => {
    const postData = {
      "functionName": "sendMailEnquiry",
      "centerName": localStorage.getItem('CenterChoosed'),
      "leadName": localStorage.getItem('Name'),
      "leadMobileNumber": localStorage.getItem('PhoneNumber'),
      "leadEmailId": localStorage.getItem('leadEmail'),
      "courseSelectedByLead": localStorage.getItem('leadCourse'),
      "toMailId": localStorage.getItem('EmailIdCenter')
    }
    saveItCareerForm(postData).then((res) => {
    })
  }
  sendWhatsAppSms = (e) => {
    const postData = {
      "functionName": "lakmeSendWhatsAppMessages",
      "userName": localStorage.getItem('Name'),
      "userNumber": localStorage.getItem('PhoneNumber'),
      "toNumber": localStorage.getItem('PhoneNumberCenter'),
      "centreName": localStorage.getItem('CenterChoosed')
    }
    dataUpdate(postData).then((res) => {
    })
  }
  handleInputChange = (e) => {
    const { value, name } = e.target;
    this.setState({
      [name]: value,
    })
    let flag = true
    let nameValidate = $("#name").val();
    let mobileNoValidate = $("#phone").val();
    var charactersName = /^[a-zA-Z\s]*$/;
    var mobile = /^[5-9][0-9]{9}$/;
    if (!nameValidate || charactersName.test(nameValidate) === false) {
      flag = false
      $("#txtCounsellingNameError").show();
      $("#Submit").attr('disabled', true);
    }
    else if (!mobileNoValidate || mobile.test(mobileNoValidate) === false) {
      flag = false
      $("#Submit").attr('disabled', true);
      $("#txtCounsellingMobileError").show();
    }
    else if (flag === true) {
      $("#Submit").attr('disabled', false);
      $("#txtCounsellingNameError").hide();
      $("#txtCounsellingMobileError").hide();
    }
  };
  finalSubmit = (e) => {
    const postData = {
      "functionName": "callMe",
      "userName": this.state.name,
      "mobileNumber": this.state.phone,
    }
    dataUpdate(postData).then((res) => {
      if (res.data.success == "1") {
        $("#hideSubmitArea").hide();
        $("#CallYouBack").show();
        var postDataMessage = {
          "brand": "LAPA",
          "userName": this.state.name,
          "mobileNumber": this.state.phone,
          "centreMobileNumber": localStorage.getItem('callMeBackNumber'),
          "functionName": "callMeSendSms",
          "centreName": localStorage.getItem('CenterChoosed')
        }
        dataUpdate(postDataMessage).then((data) => {
        });
        localStorage.setItem('Name', "")
        localStorage.setItem('PhoneNumber', "")
        localStorage.setItem('callMeBackNumber', "")
        localStorage.setItem('callNowNumber', "")
        localStorage.setItem('PhoneNumberCenter', "")
        localStorage.setItem('CenterChoosed', "")
        localStorage.setItem('EnqNo', "")
        localStorage.setItem('leadEmail', "")
        localStorage.setItem('EmailIdCenter', "")
        localStorage.setItem('leadCourse', "")
      }
    })
  }
  render() {
    return (
      <div className="thankyou-page">
        <section class="thankyouWrapper">
          <header>
            <div className="logo_blackbg">
              <a href='https://www.lakme-academy.com/'>
                <img src={Logo} className="lakme-logo" alt="Lakmé Academy Powered by Aptech" />
              </a>
            </div>
          </header>
          <div class="thankyou_innersection">
            <div class="container">
              <div class="row justify-content-center">
                <div class="thankyou-content-wrapper text-center sliderContent">
                  <div class="thankYouContent">
                    <h3 class="thankyou_head text-uppercase">Thank you!</h3>
                    <p class="thanku_para">for your enquiry.</p>
                    <p class="thanku_para">Our career counsellor will get in touch with you very soon.</p>
                    <p className="thankyou_subtext"><span className='call_href_link'>Call Us Now - </span><a href={"tel:" + localStorage.getItem('callNowNumber')} className='call_href'>{localStorage.getItem('callNowNumber')}</a>, <span>{localStorage.getItem('CenterChoosed')}</span></p>
                    <div className="thankyou_callmeback" id="hideSubmitArea">
                      <h3 className='callme_headtxt'><img src={phoneImg} alt="Phone" className='callme_icon' /> Call Me Back</h3>
                      <div className='callmeback_wrpr row'>
                        <div className='col-md-5 col-sm-5 callme_inputbx'>
                          <input type="text" placeholder='name' name="name" id="name" autoComplete="off" onChange={(e) => this.handleInputChange(e)} value={this.state.name} className='callme_input' />
                          <div class="error" id='txtCounsellingNameError'>Please enter a valid name (A-Z, a-z)</div>
                        </div>
                        <div className='col-md-5 col-sm-5 callme_inputbx'>
                          <input type="text" placeholder="phone" name="phone" id="phone" onChange={(e) => this.handleInputChange(e)} value={this.state.phone} autoComplete="off" maxlength="10" className='callme_input' />
                          <div class="error" id='txtCounsellingMobileError'>Please enter a valid mobile number</div>
                        </div>
                        <div className='col-md-2 col-sm-2 callme_inputbtn'><button className='callme_btn' id="Submit" onClick={this.finalSubmit} >Submit</button></div>
                      </div>
                    </div>
                    <div className="mt-4">
                      <h3 className='willcall_headtxt' id="CallYouBack">We Will Call You Back...</h3>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <footer class="bgdefault">
            <div class="container">
              <div class="col-sm-12 text-center no_padding">
                <p class="footer_copyright">&copy; Lakmé Academy powered by Aptech {new Date().getFullYear()}. All Rights Reserved.</p>
              </div>
            </div>
          </footer>
        </section>
      </div>
    )
  }
}

export default Thankyou